import _ from 'lodash';
import Image from 'next/image';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import WebformEmbed from '../../01_atoms/WebformEmbed';
import Container from "@material-ui/core/Container";
import {makeStyles} from '@material-ui/core/styles';

import Grid from "@material-ui/core/Grid";
import RightSidebarLayout
  from "../../04_templates/PageLayouts/RightSidebarLayout";
import SideNav from "../../02_molecules/SideNav/SideNav";
import FeaturedArticle
  from "../../02_molecules/FeaturedArticle/FeaturedArticle";
// import CarouselMuiSlider from '../../03_organisms/CarouselMuiSlider';

import { parseGutenbergReact } from '../../../api/global';
import { pickImageStyle } from "../../../utils/transforms";

const useStyles = makeStyles((theme) => ({
  authorImg: {
    textAlign: 'center',
    marginTop: '2rem',
    [`@media (min-width: 960px)`]: {
    transform: 'translate(-5rem, -1rem)',
    display: 'flex',
    '& img': {
      maxWidth: 'calc(100% + 5rem) !important',
      maxHeight: 'calc(100% + 5rem) !important',
    }
  },
  }
}),
);
// const slickSett = {
//   className: "center",
//   centerMode: false,
//   infinite: false,
//   centerPadding: "0px",
//   speed: 1500,
//   dots: true,
//   arrows: false,
// };

let layoutOpts = {
  titleBgWide: true,
  titleBgClr: "warning.dark",
  mainBgClr: false,
  mainBgImg: false,
  sideBgClr: false,
  topBgClr: false,
  blogBanner: true,
};

export default function Article(props) {
  let {
    html_title,
    node,
    metatags,
    terms_menu,
    recent,
    opts,
    children,
    blogtitle
  } = props;

  layoutOpts = opts ? { ...layoutOpts, ...opts } : layoutOpts;
  if (node?.bgSlider?.length > 0) {
    layoutOpts.topBgClr = node.bgSlider;
  }

  let {
    title,
    name,
    body,
    body_json,
    imgWidth,
    imgHeight,
    imgAlt,
    imageOrig,
    imgTitle,
    image_styles,
    nodeAuthor
  } = node;
  let isPlaceholderLogo = false;

  const getImageStyle = pickImageStyle(
    {
      imgAlt: imgAlt,
      imgTitle: imgTitle,
      imgWidth,
      imgHeight,
      imageOrig,
      image_styles,
      title,
    },
    'max_1200_width',
  );
  ({
    imgAlt,
    imgTitle,
    imgWidth,
    imgHeight,
    imageOrig,
    isPlaceholderLogo
  } = getImageStyle);

  const services_menu = [
    {
      linkUrl: "https://www.eatonrealty.com/buy",
      linkText: "Home Buying",
    },
    {
      linkUrl: "https://www.eatonrealty.com/rent",
      linkText: "Home Renting",
    },
    {
      linkUrl: "https://www.eatonrealty.com/sell",
      linkText: "Home Selling",
    },
    {
      linkUrl: "https://www.eatonrealty.com/tampa-property-management",
      linkText: "Property Management",
    },
  ];

  const sidebar = (
    <div>
      <Box mb={4} mt={2.5} className="sidebarForm" bgcolor="grey.100" p={2}
        color="grey.700">
        <Box my={2}>
          <Typography variant="h5" component="h3" align="center"><strong>Questions?
            Speak With A Real Estate Expert</strong></Typography>
        </Box>
        <WebformEmbed frameMinHeight={`500px`} key={`iframe_webform_19`}
          name={`contact_us`}
          webformid={19} html_id={`contact_us`}></WebformEmbed>
      </Box>
      <Box mb={4}>
        {terms_menu && services_menu &&
          <SideNav blockTitle="Services We Offer" titleColor="warning.main"
            items={services_menu} />
        }
      </Box>

      {terms_menu &&
        <SideNav blockTitle="ARTICLES BY
          CATEGORY" titleColor="success.main" showButton items={terms_menu} />
      }

      {recent &&
        <Box p={3} bgcolor="grey.700" mt={4}>
          <Box color="warning.main">
            <Typography variant="h5" component="h4"
              style={{ color: '#fed36b' }}><strong>FEATURED
                ARTICLES</strong></Typography>
          </Box>
          {recent?.map((val, ind) => {
            return (
              <FeaturedArticle key={`art-${ind}`} node={val} />
            );
          })}
        </Box>
      }
    </div>
  );

  let topbar = null;
  if (imageOrig) {
    topbar = (
      <Box style={{ position: 'relative', height: 400, }}>
        {isPlaceholderLogo && imageOrig &&
          <Box className="placeholder-logo" position={`relative`}>
            <Image priority style={{ objectFit: 'contain', layout: 'fill' }}
              sizes="100vw"
              src={imageOrig} alt={imgAlt}
              title={imgTitle} width={1200} height={520} />
          </Box>
        }
        {!isPlaceholderLogo && imageOrig &&
          <Box className="no-placeholder-logo">
            <Image priority style={{ objectFit: 'cover', layout: 'fill' }}
              sizes="100vw"
              src={imageOrig} alt={imgAlt}
              title={imgTitle} width={1200} height={500} />
          </Box>
        }
      </Box>
    );
  }
  const classes = useStyles();

  return (
    <RightSidebarLayout html_title={html_title} title={title || name}
      top_region={topbar} sidebar={sidebar}
      opts={layoutOpts} blogtitle={blogtitle}>
      {/*{imageOrig &&*/}
      {/*  <Image style={{layout: 'responsive'}} sizes='30vw'*/}
      {/*       src={imageOrig} alt={imgAlt}*/}
      {/*       title={imgTitle} width={370} height={220}/>*/}
      {/*}*/}

      {(body_json?.json?.length > 0) &&
        body_json.json.map((block, key) => {
          return parseGutenbergReact(key, block);
        })
      }
      {body?.length > 0 && _.isEmpty(body_json) &&
        <Typography paragraph component={`div`}
          dangerouslySetInnerHTML={{ __html: `<div class="inner-html">${body}</div>` }} />
      }
      {children}

      {(nodeAuthor?.authorDescr || nodeAuthor?.authorImage) &&
        <Box position={`relative`} bgcolor="grey.100" ml={6} mt={4}>
          <Container>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid className={classes.authorImg} item xs={12} md={3} >

                {nodeAuthor?.authorImage &&
                  <Box p={2} position={`relative`}>
                    <Image priority style={{ objectFit: 'cover', layout: 'fill' }}
                      sizes="100vw"
                      src={nodeAuthor?.authorImage} alt={nodeAuthor.imgAuthorAlt}
                      title={nodeAuthor.imgAuthorTitle} width={nodeAuthor.imgAuthorWidth || 500} height={nodeAuthor.imgAuthorHeight || 500} />
                  </Box>
                }
              </Grid>
              <Grid item md={9} xs={12}>

                  <Box p={4} position={`relative`}>
                    {nodeAuthor?.fullName?.length > 0 &&
                      <h2 className="serif m-0"><strong>{nodeAuthor?.fullName}</strong></h2>
                    }
                    {nodeAuthor?.subtitle?.length > 0 &&
                    <Box mt={3}>
                      <Typography><em>{nodeAuthor?.subtitle}</em></Typography>
                      </Box>
                    }
                    {nodeAuthor?.authorDescr?.length > 0 &&
                      <Typography paragraph component={`div`}
                        dangerouslySetInnerHTML={{ __html: `<div class="inner-html">${nodeAuthor?.authorDescr}</div>` }} />
                    }
                  </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      }

    </RightSidebarLayout>
  );
}
